export default {
    GOOGLE: {
      GTM_TRACKING_CODE: process.env.REACT_APP_GTM_TRACKING_CODE,
    },
  }
  